import { render } from "./updateAbout.vue?vue&type=template&id=a849021e&scoped=true"
import script from "./updateAbout.vue?vue&type=script&lang=js"
export * from "./updateAbout.vue?vue&type=script&lang=js"

import "./updateAbout.vue?vue&type=style&index=0&id=a849021e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a849021e"]])

export default __exports__